"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _checkboxChecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-checked2"));
var _checkboxUnchecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-unchecked2"));
var _checkboxPartial = _interopRequireDefault(require("cccisd-icons/svg/checkbox-partial2"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross4"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MultiCheckbox = function MultiCheckbox(props) {
  var options = props.options,
    field = props.field,
    form = props.form,
    label = props.label;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    search = _useState4[0],
    setSearch = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showSelected = _useState6[0],
    setShowSelected = _useState6[1];
  (0, _react.useEffect)(function () {
    if (field.value === 'all') {
      return;
    }
    var optionValues = options.map(function (option) {
      return option.value;
    });
    form.setFieldValue(field.name, (0, _intersection2["default"])(field.value, optionValues));
  }, [options]);
  var filteredOptions = (0, _react.useMemo)(function () {
    var lowerSearch = search.toLowerCase();
    return options.filter(function (item) {
      if (search && !item.label.toLowerCase().includes(lowerSearch)) {
        return false;
      }
      if (showSelected && field.value !== 'all' && !field.value.includes(item.value)) {
        return false;
      }
      return true;
    });
  }, [options, search, field.value, showSelected]);
  (0, _react.useEffect)(function () {
    if (field.value === 'all') {
      return;
    }
    if (field.value.length === options.length) {
      form.setFieldValue(field.name, 'all');
    }
  }, [field.value, options]);
  var toggleAll = function toggleAll() {
    if (field.value === 'all') {
      form.setFieldValue(field.name, []);
    } else {
      form.setFieldValue(field.name, 'all');
    }
  };
  var selectAll = function selectAll() {
    if (field.value === 'all') {
      return;
    }
    var newValue = (0, _union2["default"])(field.value, filteredOptions.map(function (item) {
      return item.value;
    }));
    form.setFieldValue(field.name, newValue);
  };
  var selectNone = function selectNone() {
    var newValue;
    if (field.value === 'all') {
      newValue = (0, _difference2["default"])(options.map(function (item) {
        return item.value;
      }), filteredOptions.map(function (item) {
        return item.value;
      }));
    } else {
      newValue = (0, _difference2["default"])(field.value, filteredOptions.map(function (item) {
        return item.value;
      }));
    }
    form.setFieldValue(field.name, newValue);
  };
  var count = /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].count
  }, "(", field.value === 'all' ? options.length : field.value.length, "/", options.length, ")");
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].group
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].check,
    onClick: function onClick() {
      return toggleAll();
    }
  }, function () {
    if (field.value === 'all') {
      return /*#__PURE__*/_react["default"].createElement(_checkboxChecked["default"], null);
    }
    if (Array.isArray(field.value) && field.value.length > 0) {
      return /*#__PURE__*/_react["default"].createElement(_checkboxPartial["default"], null);
    }
    return /*#__PURE__*/_react["default"].createElement(_checkboxUnchecked["default"], null);
  }()), /*#__PURE__*/_react["default"].createElement("label", {
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].expandIcon
  }, expanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)), label), count), expanded && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].listWrapper
  }, options.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonArea
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].searchArea
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: (0, _classnames2["default"])('form-control input-sm', _defineProperty({}, _style["default"].filled, Boolean(search))),
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    },
    placeholder: "Search..."
  }), search ? /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].clear,
    onClick: function onClick() {
      return setSearch('');
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)) : null), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default btn-sm",
    onClick: selectAll
  }, "Select all"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default btn-sm",
    onClick: selectNone
  }, "Select none"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox",
    style: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: '0.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    checked: showSelected,
    onChange: function onChange() {
      return setShowSelected(!showSelected);
    }
  }), ' ', "show selected only"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, filteredOptions.length === 0 && 'No values', filteredOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.value,
      className: "checkbox",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      onChange: function onChange() {
        var currentValue = field.value === 'all' ? options.map(function (item) {
          return item.value;
        }) : field.value;
        form.setFieldValue(field.name, (0, _xor2["default"])(currentValue, [option.value]));
      },
      checked: field.value === 'all' || field.value.includes(option.value)
    }), ' ', option.label));
  }))));
};
MultiCheckbox.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  label: _propTypes["default"].node,
  options: _propTypes["default"].array
};
var _default = MultiCheckbox;
exports["default"] = _default;